import React from 'react'
import Titulo from 'components/Titulo';
import { useStyles } from "./UserInformationStyle";
import {AccountCircle, Email} from '@mui/icons-material';
import {Container, Chip, Grid, List, ListItem, ListItemIcon, ListItemText, Divider} from '@mui/material';

export default function UserInformation (props) {
    const classes = useStyles()

    return (
        <Container>
            <Grid className={classes.colorComponente}>
                <Grid item xs={12}>
                        <br/>
                        <Titulo title="Datos del Usuario" icon="PerfilUsuario" />
                        <Divider ></Divider>
                        <List className={classes.rootLista} dense>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><AccountCircle/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Nombre completo: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.name} />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}><Email/></ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Correo electrónico: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.email} />
                            </ListItem>
                        </List>
                        <Divider ></Divider>
                        <br/><br/>
                        <Titulo title="Cambiar Contraseña" icon="cambiarContraseña" />
                        <Divider ></Divider>
                        <br/>
                </Grid>
            </Grid>
        </Container>
    )
}